import { useTranslation } from 'react-i18next'
import { ButtonLink } from '@/components/ButtonLink'
import { useBackLink } from '@/hooks/useBackLink'

export const BackButton = () => {
  const backLink = useBackLink()
  const { t } = useTranslation()

  if (!backLink) return null

  return (
    <ButtonLink
      className="flex-1 border-gray-400 text-black hover:bg-gray-100 hover:text-black"
      label={t('common.back')}
      to={backLink}
      variant="outline"
    />
  )
}
